import { ActionIcon, Group, Text, Tooltip } from '@mantine/core';
import { IconChevronLeft, IconChevronRight } from '@tabler/icons-react';
import { iconProps } from 'components/icon-props';
import { i18nKeys, useTranslation } from 'locales';
import { useParams } from 'react-router';
import { useMailDetailNavigation } from '../hooks/use-mail-detail-navigation';

export const MailDetailNavigation = () => {
  const { t } = useTranslation();
  const { id } = useParams<{ id: string }>();

  const { unprocessedNavigation } = useMailDetailNavigation(id);

  const positionLabel = unprocessedNavigation
    ? unprocessedNavigation.currentPosition !== null
      ? t(i18nKeys.EXTERNAL_MAIL.DETAIL_NEXT.NAV_POSITION, {
          position: unprocessedNavigation.currentPosition,
          total: unprocessedNavigation.total,
        })
      : t(i18nKeys.EXTERNAL_MAIL.DETAIL_NEXT.NAV_TOTAL, {
          total: unprocessedNavigation.total,
        })
    : null;

  return (
    <Group gap="space2" wrap="nowrap">
      {unprocessedNavigation && unprocessedNavigation.total > 0 && (
        <Group gap="space1" wrap="nowrap">
          <Tooltip label={t(i18nKeys.EXTERNAL_MAIL.DETAIL_NEXT.NAV_PREV_TOOLTIP)}>
            <ActionIcon
              variant="subtle"
              color="gray"
              size="sm"
              disabled={!unprocessedNavigation.hasPrev}
              onClick={() => unprocessedNavigation.onPrev({ trigger: 'button' })}
              aria-label={t(i18nKeys.EXTERNAL_MAIL.DETAIL_NEXT.NAV_PREV_ARIA)}
            >
              <IconChevronLeft {...iconProps(16)} />
            </ActionIcon>
          </Tooltip>
          <Text size="xs" c="dimmed" ff="monospace" px="space2">
            {positionLabel}
          </Text>
          <Tooltip label={t(i18nKeys.EXTERNAL_MAIL.DETAIL_NEXT.NAV_NEXT_TOOLTIP)}>
            <ActionIcon
              variant="subtle"
              color="gray"
              size="sm"
              disabled={!unprocessedNavigation.hasNext}
              onClick={() => unprocessedNavigation.onNext({ trigger: 'button' })}
              aria-label={t(i18nKeys.EXTERNAL_MAIL.DETAIL_NEXT.NAV_NEXT_ARIA)}
            >
              <IconChevronRight {...iconProps(16)} />
            </ActionIcon>
          </Tooltip>
        </Group>
      )}
    </Group>
  );
};
